export const BAD_REQUEST = 400;
export const NOT_AUTHORIZED = 401;
export const MISSING_FUNDS = 403;
export const SOMETHING_WENT_WRONG = 406;
export const BLOCKED_BY_OTHER_USER = 418;
export const ACCOUNT_SUSPENDED_BY_ADMIN = 423;

